// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const colors: Styleguide["colors"] = {
    primary: {
        main: "#cc0e33",
        contrast: "#ffffff",
    },
    secondary: {
        main: "#000000",
        contrast: "#ffffff",
    },
    tertiary: {
        main: "#000000",
        contrast: "#ffffff",
    },
    common: {
        background: "#ffffff",
        backgroundContrast: "#505D67",
        accent: "#F3F5F7",
        accentContrast: "#505D67",
        border: "#DBE0E6",
        disabled: "#DBE0E6",
        // Custom
        darkBackground: "#2c2e35",
        accentLighter: "#F8F8F8",
        backgroundRgba: "rgba(255, 255, 255, 0.9)",
        borderLight: "#F3F5F7",
        borderDark: "#9CA5B2",
        borderColored: "#071826",
        disabledLighter: "#F8F8F8",
        disabledLight: "#F3F5F7",
        carouselBackground: "rgba(44, 46, 53, 0.5)",
    },
    text: {
        main: "#000000",
        disabled: "#DBE0E6",
        accent: "#ffffff",
        link: "#cc0e33",
        // Custom
        dark: "#36404C",
        darkest: "#333333",
        linkHover: "#cc0e33",
        input: "#505d67",
    },
    success: {
        main: "#36A053",
        contrast: "#ffffff",
        light: "#E8FDEE",
    },
    danger: {
        main: "#DF1642",
        contrast: "#ffffff",
        light: "#FFE9EF",
    },
    warning: {
        main: "#DA6F14",
        contrast: "#ffffff",
        light: "#FEF7EA",
        // Custom
        icon: "#ffff00",
    },
    info: {
        main: "#518CE3",
        contrast: "#EEF9FF",
        // Custom
        alt: "#DCE2F1",
    },
    header: {
        accent: "#ffffff",
        accentHover: "#ffffff",
    },
};

export default colors;
